import { atom, createStore } from 'jotai';

export const feedbackUIAvailabilityAtom = atom<boolean>(false);
feedbackUIAvailabilityAtom.debugLabel = 'FeedbackUIAvailabilityAtom';

export const jotaiStore = createStore();
